import * as Constants from './constants'

export const chuongTrinhListRequest = function chuongTrinhListRequest(formData) {
  return {
    type: Constants.CHUONGTRINH_LIST_REQUESTING,
    payload: formData
  }
}

export const chuongTrinhListSuccess = function chuongTrinhListSuccess(data) {
  return {
    type: Constants.CHUONGTRINH_LIST_SUCCESS,
    data
  }
}

export const chuongTrinhListError = function chuongTrinhListError(error) {
  return {
    type: Constants.CHUONGTRINH_LIST_ERROR,
    error
  }
}

export const chuongTrinhDetailRequest = (formData, callback) => {
  return {
    type: Constants.CHUONGTRINH_DETAIL_REQUESTING,
    payload: formData,
    callback
  }
}

export const chuongTrinhDetailSuccess = (data) => {
  return {
    type: Constants.CHUONGTRINH_DETAIL_SUCCESS,
  }
}

export const chuongTrinhDetailError = (error) => {
  return {
    type: Constants.CHUONGTRINH_DETAIL_ERROR,
    error
  }
}

export const chuongTrinhUpdateRequest = (formData, callback) => {
  return {
    type: Constants.CHUONGTRINH_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const chuongTrinhUpdateSuccess = function chuongTrinhUpdateSuccess(response) {
  return {
    type: Constants.CHUONGTRINH_UPDATE_SUCCESS,
    payload: response
  }
}

export const chuongTrinhUpdateError = function chuongTrinhUpdateError(error) {
  return {
    type: Constants.CHUONGTRINH_UPDATE_ERROR,
    error
  }
}

export const chuongTrinhNganhHangListRequest = function chuongTrinhNganhHangListRequest(formData) {
  return {
    type: Constants.CHUONGTRINH_NGANHHANG_LIST_REQUESTING,
    payload: formData
  }
}

export const chuongTrinhNganhHangListSuccess = function chuongTrinhNganhHangListSuccess(data) {
  return {
    type: Constants.CHUONGTRINH_NGANHHANG_LIST_SUCCESS,
    data
  }
}

export const chuongTrinhNganhHangListError = function chuongTrinhNganhHangListError(error) {
  return {
    type: Constants.CHUONGTRINH_NGANHHANG_LIST_ERROR,
    error
  }
}

export const chuongTrinhProductListRequest = function chuongTrinhProductListRequest(formData) {
  return {
    type: Constants.CHUONGTRINH_PRODUCT_LIST_REQUESTING,
    payload: formData
  }
}

export const chuongTrinhProductListSuccess = function chuongTrinhProductListSuccess(data) {
  return {
    type: Constants.CHUONGTRINH_PRODUCT_LIST_SUCCESS,
    data
  }
}

export const chuongTrinhProductListError = function chuongTrinhProductListError(error) {
  return {
    type: Constants.CHUONGTRINH_PRODUCT_LIST_ERROR,
    error
  }
}

export const chuongTrinhUpdateProductRequest = (formData, callback) => {
  return {
    type: Constants.CHUONGTRINH_UPDATE_PRODUCT_REQUESTING,
    payload: formData,
    callback
  }
}

export const chuongTrinhUpdateProductSuccess = function chuongTrinhUpdateProductSuccess(response) {
  return {
    type: Constants.CHUONGTRINH_UPDATE_PRODUCT_SUCCESS,
    payload: response
  }
}

export const chuongTrinhUpdateProductError = function chuongTrinhUpdateProductError(error) {
  return {
    type: Constants.CHUONGTRINH_UPDATE_PRODUCT_ERROR,
    error
  }
}

export const chuongTrinhListNhomKhRequest = (payload, callback) => {
  return {
    type: Constants.CHUONGTRINH_LIST_NHOM_KH_REQUESTING,
    payload,
    callback
  }
}



// WEBPACK FOOTER //
// ./src/views/ChuongTrinh/actions.js